module.exports = __webpack_public_path__ + "img/cicon3.25bd9fb7.png";